// PR 2026-10-24 (back logo), extended 2026-10-25 (12+ decoration upgrade): keeps each mockneck add-on cart line
// locked to the shirts that carry its property. Add-on quantity/remove controls are hidden in the cart
// (snippets/cart-drawer.liquid, sections/main-cart-items.liquid); this script corrects the add-on
// quantities after any cart change, including removing or editing the shirt line.
(function () {
  var ADDONS = [
    { product: 8930229846151, variant: 46305105510535, props: { For: 'Back logo on custom mockneck' },
      need: function (it) { return it.properties && /^Yes/.test(it.properties['Back logo add-on'] || '') ? it.quantity : 0; } },
    { product: 8932403937415, variant: 46314380099719, props: { For: 'Embroidered upgrade on custom mockneck (12+)' },
      need: function (it) { return it.properties && it.properties['Decoration'] === 'Embroidered' ? it.quantity : 0; } },
    { product: 8932403937415, variant: 46314380132487, props: { For: 'Appliqué patch upgrade on custom mockneck (12+)' },
      need: function (it) { return it.properties && it.properties['Decoration'] === 'Appliqué patch' ? it.quantity : 0; } }
  ];
  var ADDON_PRODUCTS = ADDONS.map(function (a) { return a.product; });
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function json(url, opts) {
    return fetch(root + url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts)).then(function (r) { return r.json(); });
  }

  function rerender() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return Promise.resolve(); }
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var doc = new DOMParser().parseFromString(s['cart-drawer'] || '', 'text/html');
      var cur = document.querySelector('#CartDrawer'), next = doc.querySelector('#CartDrawer');
      if (cur && next) cur.innerHTML = next.innerHTML;
      var drawer = document.querySelector('cart-drawer'), nextDrawer = doc.querySelector('cart-drawer');
      if (drawer && nextDrawer) drawer.classList.toggle('is-empty', nextDrawer.classList.contains('is-empty'));
      var bubble = document.getElementById('cart-icon-bubble');
      var bdoc = new DOMParser().parseFromString(s['cart-icon-bubble'] || '', 'text/html');
      var bsec = bdoc.querySelector('.shopify-section');
      if (bubble && bsec) bubble.innerHTML = bsec.innerHTML;
    });
  }

  function sync() {
    if (busy) return;
    busy = true;
    json('cart.js').then(function (cart) {
      var updates = {}, adds = [], changed = false;
      ADDONS.forEach(function (a) {
        var need = 0, lines = [];
        cart.items.forEach(function (it) {
          if (it.variant_id === a.variant) lines.push(it);
          else if (ADDON_PRODUCTS.indexOf(it.product_id) === -1) need += a.need(it);
        });
        var have = lines.reduce(function (n, it) { return n + it.quantity; }, 0);
        if (have === need && lines.length <= 1) return;
        changed = true;
        if (!lines.length) { if (need > 0) adds.push({ id: a.variant, quantity: need, properties: a.props }); return; }
        lines.forEach(function (it, i) { updates[it.key] = i === 0 ? need : 0; });
      });
      if (!changed) return false;
      var p = Promise.resolve();
      if (Object.keys(updates).length) p = p.then(function () { return json('cart/update.js', { method: 'POST', body: JSON.stringify({ updates: updates }) }); });
      if (adds.length) p = p.then(function () { return json('cart/add.js', { method: 'POST', body: JSON.stringify({ items: adds }) }); });
      return p.then(function () { return true; });
    }).then(function (changed) {
      return changed ? rerender() : null;
    }).catch(function () {}).then(function () { busy = false; });
  }

  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sync, 150); });
    }
    if (document.querySelector('.pr-addon-line')) sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
